/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListReview = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="m4.707 6.707 4-4-1.414-1.414L4 4.586 2.707 3.293 1.293 4.707l2 2L4 7.414zM11 4h10V2H11zM8.707 8.707 7.293 7.293 4 10.586 2.707 9.293l-1.414 1.414 2 2 .707.707.707-.707zM11 10h10V8H11zm-6.293 8.707 4-4-1.414-1.414L4 16.586l-1.293-1.293-1.414 1.414 2 2 .707.707zM22 16v2h-1.141a3.956 3.956 0 0 1-.425 1.02l.808.808-1.414 1.414-.808-.808c-.316.186-.656.33-1.02.425V22h-2v-1.141a3.991 3.991 0 0 1-1.02-.425l-.809.808-1.414-1.414.809-.808a3.991 3.991 0 0 1-.425-1.02H12v-2h1.141c.095-.364.239-.704.425-1.02l-.809-.808 1.415-1.415.808.809c.316-.187.656-.33 1.02-.425V12h2v1.141c.364.095.704.238 1.02.425l.808-.809 1.414 1.415-.808.808c.187.316.33.656.425 1.02zm-7 1a2 2 0 1 0 4.001-.001A2 2 0 0 0 15 17z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgListReview as ListReview };
